<jsg-multi-row-panel [showSeparator]="true">
  <jsg-single-row-panel first>
    <div first>
      <div>Action number</div>
      <div>{{ actionNumber }}</div>
    </div>
    <div second>
      <div>Style of cause</div>
      <div>{{ styleOfCause }}</div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel second>
    <div first>
      <div>Judicial center</div>
      <div>{{ judicialCenter }}</div>
    </div>
    <div second>
      <div>Area of law</div>
      <div>{{ areaOfLaw }}</div>
    </div>
  </jsg-single-row-panel>
</jsg-multi-row-panel>
